import { Button, IconButton, Stack, TextField, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import Iconify from "minimals-template/components/Iconify"
import { MACRO_NAME_ERROR, isValidMacroName } from "authoring/routes/macro/lib/macro-utils"
import { AUTHORING_MANAGE_MACROS_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function MacroEditorHeader({
    macro,
    editMode,
    isEditingName,
    nameInput,
    savingName,
    isNameDirty,
    onStartEdit,
    onNameChange,
    onConfirmEdit,
    onCancelEdit,
}) {
    return (
        <If truthy={isEditingName && editMode}>
            <TextField
                label="Macro name"
                value={nameInput}
                onChange={onNameChange}
                size="small"
                error={!!getNameError(nameInput)}
                helperText={getNameError(nameInput) || " "}
                disabled={savingName}
            />
            <Stack direction="row" spacing={1}>
                <Button
                    size="small"
                    variant="contained"
                    onClick={onConfirmEdit}
                    disabled={!isNameDirty || savingName}
                    data-cy="macro-save-name-button"
                >
                    Save name
                </Button>
                <Button size="small" variant="text" onClick={onCancelEdit} disabled={savingName}>
                    Cancel
                </Button>
            </Stack>
            <Else>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="h5" data-cy="macro-editor-title">
                        {macro?.name ?? "Macro"}
                    </Typography>
                    <If truthy={editMode}>
                        <Secure demand={AUTHORING_MANAGE_MACROS_DEMAND} fallback={<Frag />}>
                            <IconButton
                                aria-label="Edit macro name"
                                size="small"
                                color="primary"
                                onClick={onStartEdit}
                                data-cy="macro-edit-name-button"
                            >
                                <Iconify icon="mdi:pencil" />
                            </IconButton>
                        </Secure>
                    </If>
                </Stack>
            </Else>
        </If>
    )
}

function getNameError(value) {
    if (!value?.trim()) return ""
    if (!isValidMacroName(value)) return MACRO_NAME_ERROR
    return ""
}
